import controller from './user-admin-controller';
import template from './user-admin.html'

const UserAdminComponent = {
    bindings: {
        clientList: '<',
        permissionList: '<',
        roleList: '<',
        userList: '<'
    },
    controller,
    template,
};

export default UserAdminComponent;



// WEBPACK FOOTER //
// ./app/components/user-admin/user-admin-component.js